//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Skeleton } from '@backmarket/design-system'

export default {
  components: {
    Skeleton,
  },
}
